import ServicePageLayout from "@/components/ServicePageLayout";
import { IMAGES } from "@/data/site";

export default function ConstructionRenovation() {
    return (
        <ServicePageLayout
            seoTitle="Construction & Renovation Consultancy | Gorakhpur"
            seoDescription="Independent construction and renovation consultancy in Gorakhpur — material selection, workmanship review, estimates and practical execution decisions."
            overline="Construction & Renovation Consultancy"
            title="Build or Renovate with an Independent Expert Beside You"
            heroDescription="Independent guidance for construction, renovation, material selection, workmanship review, estimates and practical execution decisions."
            image={IMAGES.residential.url}
            imageAlt={IMAGES.residential.alt}
            intro={[
                "Most homeowners build once or twice in a lifetime; contractors build every day. That gap in experience is where costly mistakes and compromises happen.",
                "This consultancy closes that gap. From the first estimate to the final finish, you get an experienced, independent view on materials, workmanship, sequence and cost — so decisions are made on facts, not pressure.",
            ]}
            coveredTitle="What the Consultancy Covers"
            covered={[
                "Review of drawings, estimates and proposed work scopes",
                "Guidance on material selection — brands, grades and alternatives",
                "Workmanship review at key construction stages",
                "Practical advice on execution sequence and site decisions",
                "Renovation planning — what to retain, repair or rebuild",
                "Independent opinion before major payments or changes",
            ]}
            closing="The consultancy does not execute work and has no tie with any contractor or supplier — the guidance you receive is entirely independent."
            ctaLabel="Book a Consultation"
            ctaLink="/contact?service=Construction%20Consultancy"
        />
    );
}
